import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { ANIMATION_DURATION_IN_MS, TOOLTIP_CONTENT_CLASSNAME } from './constants';

const ANCHOR_HEIGHT = 24;

export const tooltipTextButton = css`
  background: none;
  color: var(--brand-purple-base);
  text-decoration: underline;
  border: none;
  padding: 0;
  font: inherit;
  outline: inherit;
`;

export const tooltipTextButtonWrapper = css`
  &[data-alignment='center'] {
    text-align: center;
  }

  &[data-alignment='right'] {
    text-align: right;
  }

  &[data-alignment='left'] {
    text-align: left;
  }
`;

export const tooltipButtonWrapper = css`
  position: relative;

  .${TOOLTIP_CONTENT_CLASSNAME}-enter {
    transform: scale(0.9);
    opacity: 0;
    transition: all ${ANIMATION_DURATION_IN_MS}ms;
  }

  .${TOOLTIP_CONTENT_CLASSNAME}-enter-active {
    transform: scale(1);
    opacity: 1;
    transition: all ${ANIMATION_DURATION_IN_MS}ms;
  }

  .${TOOLTIP_CONTENT_CLASSNAME}-exit {
    transform: scale(1);
    opacity: 1;
    transition: all ${ANIMATION_DURATION_IN_MS}ms;
  }

  .${TOOLTIP_CONTENT_CLASSNAME}-exit-active {
    transform: scale(0.9);
    opacity: 0;
    transition: all ${ANIMATION_DURATION_IN_MS}ms;
  }
`;

export const tooltipButtonContentContainer = css`
  position: absolute;
  width: 100%;
  top: calc(100% + ${pxToRem(ANCHOR_HEIGHT)});
  right: 0px;
  z-index: 200;
  background: #fff;
  border-radius: ${pxToRem(10)};
  box-shadow: 0 0 ${pxToRem(8)} ${pxToRem(3)} rgba(0, 0, 0, 0.2);
  padding: ${pxToRem(16)};
  ${theme.responsiveText.BODY.XS};
`;
